module.exports = __webpack_public_path__ + "img/97.40ce32be.jpg";